/**
 * 打点封装模块
 */
import { nativeApi } from '@dym/client-bridge';
import { mCookie } from '@mshark/base';
import DYBrowser from '../base';

const $SYS = window.$SYS || {};

export default class DYPoint {
    constructor(page_code) {
        this.config = {
            action_code: '',
            page_code, // DYS 2.0有bug 必须要调用setPageCode 函数
            ct_code: 'h5',
            pro_code: DYBrowser.isIOS ? 'ios' : 'android',
            ext: null
        };

        this.initPoint();
    }

    // 获取did
    getDid() {
        if ($SYS && $SYS.cookie_pre) {
            const didkey = `${$SYS.cookie_pre}did`;

            try {
                if (!(DYBrowser.isDyAndroid || DYBrowser.isDyIOS)) {
                    if (!mCookie.getItem(didkey)) {
                        let passportUrl = $SYS.passport_host || 'https://passport.douyu.com';

                        passportUrl = passportUrl.replace(/\/$/, '');
                        // 无斗鱼客户的did时，种入前端did
                        $.ajax({
                            url: `${passportUrl}/lapi/did/api/get`,
                            data: { client_id: 25 },
                            type: 'get',
                            dataType: 'jsonp',
                            success: (res) => {
                                if (res && +res.error === 0) {
                                    const did = res.data && res.data.did;

                                    mCookie.setItem(didkey, did);
                                }
                            },
                            error: () => {
                                console.warn('did 请求失败');
                            }
                        });
                    }
                } else {
                    let did = mCookie.getItem(didkey);

                    // 客户端环境并且php已注入did，自动上报did
                    if (!did) {
                        nativeApi.jsNative.getAppInfo({}, (res) => {
                            const oData = res && res.data;

                            did = oData && oData.did;
                            mCookie.setItem(didkey, did);
                        });
                    }
                }
            } catch (e) {
                console.warn('[mShark-base]: did make failed');
            }
        } else {
            console.warn('[mShark-base]: $SYS.cookie_pre is required by php');
        }
    }

    // 打点准备
    initPoint () {
        const settings = this.config;

        // 设备唯一码（打点需要）
        this.getDid();

        // 设置点位页面标识
        if (window.DYS) {
            window.DYS.sub.setPageCode(settings.page_code);
        } else {
            const script = document.createElement('script');

            script.src = 'https://shark.douyucdn.cn/stream/dist/dys-douyutv.js?v=1.2.8';
            document.body.appendChild(script);
            script.onload = () => {
                console.log('[mShark-base]: dys-js load success!');
                window.DYS.sub.setPageCode(settings.page_code);
            };
        }
    }

    /*
     * 打点上报
     * @param {String} action_code 点位名称
     * @param {Object} ext 附加参数
     */
    sub(action_code, ext = {}) {
        const didkey = `${$SYS.cookie_pre}did`;

        if (!mCookie.getItem(didkey)) {
            let count = 0;
            const subTimer = setInterval(() => {
                if (mCookie.getItem(didkey) || count > 10) {
                    clearInterval(subTimer);
                    window.DYS && DYS.sub(Object.assign(this.config, { action_code, ext }));
                } else {
                    count++;
                }
            }, 200);
        } else {
            window.DYS && DYS.sub(Object.assign(this.config, { action_code, ext }));
        }
    }

    // 百度打点
    setBaiduPointSub(actionCode, extjson) {
        const that = this;
        const funSrc = 'DyBaseFun,setBaiduPointSub';

        if (window._hmt) {
            const impl = (code, ext) => {
                window._hmt.push(['_trackEvent', that.config.page_code, code, 'ext', JSON.stringify(ext)]);
            };

            impl(actionCode, extjson);
            this.setBaiduPointSub = impl;
        } else {
            console.warn('_hmt is null', funSrc);
        }
    }
}
